import { FC } from 'react';
import { Flex, Typography } from 'antd';
import { SLabelTitle, ModalDialog, SDatePicker } from '../..';
import { IProps } from './type';
import styles from '../../../assets/styles/index.module.scss';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DATE_FORMAT } from '../../../assets/conts';

dayjs.extend(customParseFormat);

const GroupHealthInsuranceIndividualsCancelModal: FC<IProps> = (props) => {
  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        <Flex justify="space-between">
          <SLabelTitle>Şirket Bilgileri</SLabelTitle>
          <Typography className={styles.labelValue}>
            {
              props.organizations.find(
                (item) => item.id === (props.item?.organization ?? 0),
              )?.name
            }
          </Typography>
        </Flex>
        <Flex justify="space-between">
          <SLabelTitle>Kişi Bilgileri</SLabelTitle>
          <Typography className={styles.labelValue}>
            {props.item?.first_name} {props.item?.last_name}
          </Typography>
        </Flex>
        <Flex justify="space-between">
          <SLabelTitle>İşten Çıkış Tarihi</SLabelTitle>
          <SDatePicker
            id="date_of_employment"
            name="date_of_employment"
            onChange={(date) => {
              if (date) {
                props.setDateOfTermination(date.format(DATE_FORMAT));
              }
            }}
          />
        </Flex>
      </Flex>
    </ModalDialog>
  );
};

export default GroupHealthInsuranceIndividualsCancelModal;
